import { getRoleNotificationSetting } from './roleNotificationSettings';

// Display aliases only: API requests and row indexes keep the original sheet schema.
const SHEET_DISPLAY_NAMES = Object.freeze({
  correos_notificaciones_usuarios: 'Correo notificaciones',
  contrasenas_acceso_usuarios: 'Contraseñas de acceso',
  'usuarios para revisar': 'Usuarios por revisar',
});

const USUARIOS_COLUMN_DISPLAY_NAMES = Object.freeze({
  'iglesia - estado': 'Estado/Prov./Dept.',
  'iglesia - ciudad': 'Ciudad',
  'iglesia - nombre': 'Barrio',
});

function formatCountryLabel(value) {
  return String(value ?? '').replace(/\bPais\b/gi, (word) => (
    word === word.toUpperCase() ? 'PAÍS' : (word[0] === 'P' ? 'País' : 'país')
  ));
}

export function getSheetDisplayName(sheetName) {
  const name = String(sheetName ?? '').trim();
  return SHEET_DISPLAY_NAMES[name.toLowerCase()] || formatCountryLabel(name);
}

export function formatSheetDisplayText(value) {
  return Object.entries(SHEET_DISPLAY_NAMES).reduce(
    (text, [name, label]) => text.replace(new RegExp(`\\b${name}\\b`, 'gi'), label),
    formatCountryLabel(value)
  );
}

export function getColumnDisplayName(header, sheetName = '') {
  const name = String(header ?? '').trim();
  if (String(sheetName).trim().toLowerCase() === 'roles') {
    return getRoleNotificationSetting(name)?.label || formatCountryLabel(name);
  }
  if (String(sheetName).trim().toLowerCase() === 'usuarios') {
    return USUARIOS_COLUMN_DISPLAY_NAMES[name.toLowerCase()] || formatCountryLabel(name);
  }
  return formatCountryLabel(name);
}
